export default {
  lang: {
    reset: 'Zresetuj',
    search: 'Filtr',
    expand: 'Rozwiń',
    collapse: 'Stow',
  },
};
